/**
 * Shared Utils
 */
import { ITopLevelDomains } from "@thekilroygroup/shared-ui";

export const getCookieDisclaimer = (toplevelDomain: ITopLevelDomains) => {
  const script = document.createElement("script");
  script.src = "https://policy.app.cookieinformation.com/uc.js";
  script.id = "CookieConsent";
  script.type = "text/javascript";
  script.dataset.culture = toplevelDomainToCookieCulture[toplevelDomain];
  script.async = true;
  return script;
};

const toplevelDomainToCookieCulture = {
  net: "EN",
  "co.uk": "EN",
  dk: "DA",
  be: "NL",
  nl: "NL",
  fi: "FI",
  is: "IS",
  no: "NB",
  se: "SV",
};

// Read the confirmationToken cookie
export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift();
  return undefined;
};

export const setCookie = (
  name: string,
  value: string,
  date: Date,
  path: string = "/",
) => {
  let expires = "";
  expires = "; expires=" + date.toUTCString();
  path = "; expires=" + path;

  document.cookie = `${name}=${encodeURIComponent(
    value || "",
  )}${expires}${path}; Secure; SameSite=Lax`;
};
